module.exports = __webpack_public_path__ + "static/media/occ.b6a68c1f.png";